import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=05ec0270&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ec0270')) {
      api.createRecord('05ec0270', component.options)
    } else {
      api.reload('05ec0270', component.options)
    }
    module.hot.accept("./Confirmation.vue?vue&type=template&id=05ec0270&", function () {
      api.rerender('05ec0270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/auth/Confirmation.vue"
export default component.exports